/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpgatesAddonInstall200Response
 */
export interface UpgatesAddonInstall200Response {
    /**
     * 
     * @type {boolean}
     * @memberof UpgatesAddonInstall200Response
     */
    error?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpgatesAddonInstall200Response
     */
    message?: string;
}

/**
 * Check if a given object implements the UpgatesAddonInstall200Response interface.
 */
export function instanceOfUpgatesAddonInstall200Response(value: object): value is UpgatesAddonInstall200Response {
    return true;
}

export function UpgatesAddonInstall200ResponseFromJSON(json: any): UpgatesAddonInstall200Response {
    return UpgatesAddonInstall200ResponseFromJSONTyped(json, false);
}

export function UpgatesAddonInstall200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpgatesAddonInstall200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'error': json['error'] == null ? undefined : json['error'],
        'message': json['message'] == null ? undefined : json['message'],
    };
}

export function UpgatesAddonInstall200ResponseToJSON(json: any): UpgatesAddonInstall200Response {
    return UpgatesAddonInstall200ResponseToJSONTyped(json, false);
}

export function UpgatesAddonInstall200ResponseToJSONTyped(value?: UpgatesAddonInstall200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'error': value['error'],
        'message': value['message'],
    };
}

